import * as React from "react";
import styled from "../../styled";
export const ModalFieldLabel = styled("div") `
	margin-bottom: 6px;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	color: #414651;
`;
export const ModalActionButtonRow = styled("div") `
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
`;
export const ModalActionButton = styled("button") `
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 12px;
	border: 1px solid #d5d7da;
	border-radius: 8px;
	background: #f1f4f7;
	color: #414651;
	font-family: inherit;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	cursor: pointer;
	box-shadow: 0 1px 2px rgba(10, 13, 18, 0.05);
	&:hover {
		background: #e8eaed;
	}
`;
const Grid = styled("div") `
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
`;
const StatusBtn = styled("button") `
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 12px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	font-family: inherit;
	cursor: pointer;
	white-space: nowrap;
	transition: background 0.15s, border-color 0.15s;
	box-shadow: 0 1px 2px rgba(10, 13, 18, 0.05);
	${({ active }) => active
    ? "background: #fff3f3; border: 1px solid #fda29b; color: #fb2f2f;"
    : "background: #f1f4f7; border: 1px solid #d5d7da; color: #414651;"}
	&:disabled {
		cursor: default;
		${({ active }) => (active ? "" : "opacity: 0.5;")}
	}
	&:not(:disabled):hover {
		background: ${({ active }) => (active ? "#ffe4e4" : "#e8eaed")};
	}
`;
/** 2-column status picker used by the admin order + booking modals. The current status is highlighted and not clickable. */
export function StatusButtonGrid(props) {
    const { options, current, onSelect, label } = props;
    return (React.createElement("div", null,
        label && React.createElement(ModalFieldLabel, null, label),
        React.createElement(Grid, null, options.map((o) => {
            const active = o.value === current;
            return (React.createElement(StatusBtn, { key: o.value, type: "button", active: active, disabled: active || !!o.disabled, onClick: () => onSelect(o.value) }, o.label));
        }))));
}
//# sourceMappingURL=status-button-grid.js.map